import { getMemberIdFromAuthCookie, getExpiryFromAuthCookie } from './cookies';

const getClientIPFromXForwardedForHeader = (req) => {
    // In production, we will get the X-Forwarded-For header from the Google's Load Balancer and Kubernetes Proxy.
    // See https://stackoverflow.com/a/46691172, the header will come in the following format:
    // X-Forwarded-For: <unverified IP(s)?>, <immediate-client-IP>, <google-load-balancer>, <kubernetes-proxy?>
    // For the purpose of logging we make it simple and assume there are no unverified IPs at the beginning of the header.
    return req.headers?.['x-forwarded-for']?.split(',').shift().trim();
};

const getClientIPFromXRealIPHeader = (req) => {
    return req.headers?.['x-real-ip'];
};

const getClientIP = (req) => {
    return (
        getClientIPFromXForwardedForHeader(req) ||
        getClientIPFromXRealIPHeader(req) ||
        req.socket?.remoteAddress
    );
};

export const getLoggingContext = (context = {}) => {
    const { locale, req = {}, resolvedUrl } = context;
    const { headers = {}, method, url } = req;
    const memberId = getMemberIdFromAuthCookie(req);
    const authTokenExpiry = getExpiryFromAuthCookie(req);
    const loggingContext = {
        method,
        url: resolvedUrl || url,
        locale,
        ip: getClientIP(req),
        userAgent: headers['user-agent'],
        referer: headers['referer'],
        memberId,
        authTokenExpiry
    };
    return loggingContext;
};

export const getErrorMessage = (error) => {
    switch (typeof error) {
        case 'string':
            return error;
        case 'object':
            if (error?.name && error?.message) {
                return `${error.name}: ${error.message}`;
            } else if (error?.message) {
                return error.message;
            }
            return `unknown error object: ${error}`;
        default:
            return `unknown error type caught: ${error}`;
    }
};
